/**
 * `/calendar-connected` — the public page (no login) where the interviewer calendar request email's link ends: after
 * Google's consent, or straight away when the link can't be used. The backend builds the address
 * (backend calendar_connections/result_page.py) and sends only what the page shows.
 */
export const CALENDAR_CONNECTED_PATH = "/calendar-connected";

const RESULT_PARAM = "result";
const DEPARTMENT_NAME_PARAM = "department";

/** The `result=` values (backend CalendarLinkResult). */
export enum CalendarLinkResult {
	Connected = "connected",
	ConfirmNeeded = "confirm_needed",
	Failed = "failed",
	Expired = "expired",
	Used = "used",
	AlreadyConnected = "already_connected",
	NotAvailable = "not_available",
}

/** What the page shows: connected names the department; every other outcome is its sentence alone. */
export type CalendarConnectedView =
	| { result: CalendarLinkResult.Connected; department: string }
	| { result: Exclude<CalendarLinkResult, CalendarLinkResult.Connected> };

/** The view an address asks for; null for one the backend never sends (an unknown result, connected with no department). */
export const calendarConnectedViewFromParams = (params: URLSearchParams): CalendarConnectedView | null => {
	const result = Object.values(CalendarLinkResult).find((value) => value === params.get(RESULT_PARAM));
	switch (result) {
		case undefined:
			return null;
		case CalendarLinkResult.Connected: {
			const department = params.get(DEPARTMENT_NAME_PARAM);
			return department === null || department === "" ? null : { result, department };
		}
		default:
			return { result };
	}
};
